import { useState } from "react";
import { PsqiCreate } from "./PsqiCreate";
import { useLoaderData, useParams } from "react-router-dom";

export function PsqiNew(props) {
  const psqi = useLoaderData();

  // mensaje de advertencia al no contstar a las preguntas necesarias del formulario
  const [missingQuestionsMessage, setMissingQuestionsMessage] = useState("");
  const [isMissingQuestionsModalOpen, setIsMissingQuestionsModalOpen] = useState(false);

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  // Set number of sesion based on number of items published
  let psqiLength = psqi.length;
  let currentSesion = psqiLength + 1;

  const [psqiResp, setPsqiResp] = useState(props.especialistaFullName);
  const [metaFecha, setPsqiFecha] = useState(todayDate);
  const [psqiPreg001, setPsqiPreg001] = useState("");
  const [psqiPreg002, setPsqiPreg002] = useState("");
  const [psqiPreg003, setPsqiPreg003] = useState("");
  const [psqiPreg004, setPsqiPreg004] = useState("");
  const [psqiPreg005a, setPsqiPreg005a] = useState("");
  const [psqiPreg005b, setPsqiPreg005b] = useState("");
  const [psqiPreg005c, setPsqiPreg005c] = useState("");
  const [psqiPreg005d, setPsqiPreg005d] = useState("");
  const [psqiPreg005e, setPsqiPreg005e] = useState("");
  const [psqiPreg005f, setPsqiPreg005f] = useState("");
  const [psqiPreg005g, setPsqiPreg005g] = useState("");
  const [psqiPreg005h, setPsqiPreg005h] = useState("");
  const [psqiPreg005i, setPsqiPreg005i] = useState("");
  const [psqiPreg005j, setPsqiPreg005j] = useState("");
  const [psqiPreg005k, setPsqiPreg005k] = useState("");
  const [psqiPreg006, setPsqiPreg006] = useState(null);
  const [psqiPreg007, setPsqiPreg007] = useState(null);
  const [psqiPreg008, setPsqiPreg008] = useState("");
  const [psqiPreg009, setPsqiPreg009] = useState("");
  const [psqiPreg010, setPsqiPreg010] = useState("");
  const [psqiPreg010a, setPsqiPreg010a] = useState("");
  const [psqiPreg010b, setPsqiPreg010b] = useState("");
  const [psqiPreg010c, setPsqiPreg010c] = useState("");
  const [psqiPreg010d, setPsqiPreg010d] = useState("");
  const [psqiPreg010e, setPsqiPreg010e] = useState("");
  const [psqiPreg010f, setPsqiPreg010f] = useState("");

  // Operaciones para resultado de componente 1 de PSQI

  const totalSumComp1 = psqiPreg006 !== null ? parseInt(psqiPreg006) : 0;

  // Operaciones para resultado de componente 2 de PSQI

  const psqiPreg002Value =
    psqiPreg002 >= 0 && psqiPreg002 <= 15
      ? 0
      : psqiPreg002 >= 16 && psqiPreg002 <= 30
      ? 1
      : psqiPreg002 >= 31 && psqiPreg002 <= 60
      ? 2
      : psqiPreg002 > 60
      ? 3
      : "";

  const totalSum2And5a =
    (psqiPreg002Value || 0) + (parseInt(psqiPreg005a) || 0);

  const totalSumComp2 =
    totalSum2And5a < 1
      ? 0
      : totalSum2And5a >= 1 && totalSum2And5a <= 2
      ? 1
      : totalSum2And5a >= 3 && totalSum2And5a <= 4
      ? 2
      : totalSum2And5a >= 5 && totalSum2And5a <= 6
      ? 3
      : "";

  // Operaciones para resultado de componente 3 de PSQI

  const totalSumComp3 =
    psqiPreg004 < 5
      ? 3
      : psqiPreg004 >= 5 && psqiPreg004 < 6
      ? 2
      : psqiPreg004 >= 6 && psqiPreg004 <= 7
      ? 1
      : psqiPreg004 > 7
      ? 0
      : "";

  // Operaciones para resultado de componente 4 de PSQI

  const date1 = new Date(`2000-01-01T${psqiPreg001}`);
  const date2 = new Date(`2000-01-01T${psqiPreg003}`);

  // Verifica si el valor de psqiPreg001 es anterior a psqiPreg003
  if (date1 > date2) {
    // Si psqiPreg001 es anterior, agrega un día a la fecha de psqiPreg001
    date1.setDate(date1.getDate() - 1);
  }

  // Calcula la diferencia en milisegundos
  const diffInMilliseconds = Math.abs(date2 - date1);

  // Calcula la diferencia en horas
  const diffInHours = diffInMilliseconds / (1000 * 60 * 60);

  const psqiComp4EficSue = Math.trunc(
    (parseInt(psqiPreg004) / diffInHours) * 100
  );

  const totalSumComp4 =
    psqiComp4EficSue < 65
      ? 3
      : psqiComp4EficSue >= 65 && psqiComp4EficSue <= 74
      ? 2
      : psqiComp4EficSue >= 75 && psqiComp4EficSue <= 84
      ? 1
      : psqiComp4EficSue >= 85
      ? 0
      : "";

  // Operaciones para resultado de componente 5 de PSQI

  const totalSumPregPsqi005 =
    (parseInt(psqiPreg005b) || 0) +
    (parseInt(psqiPreg005c) || 0) +
    (parseInt(psqiPreg005d) || 0) +
    (parseInt(psqiPreg005e) || 0) +
    (parseInt(psqiPreg005f) || 0) +
    (parseInt(psqiPreg005g) || 0) +
    (parseInt(psqiPreg005h) || 0) +
    (parseInt(psqiPreg005i) || 0) +
    (parseInt(psqiPreg005k) || 0);

  const totalSumComp5 =
    totalSumPregPsqi005 <= 0
      ? 0
      : totalSumPregPsqi005 >= 1 && totalSumPregPsqi005 <= 9
      ? 1
      : totalSumPregPsqi005 >= 10 && totalSumPregPsqi005 <= 18
      ? 2
      : totalSumPregPsqi005 >= 19 && totalSumPregPsqi005 <= 27
      ? 3
      : "";

  // Operaciones para resultado de componente 6 de PSQI
  const totalSumComp6 = psqiPreg007 !== null ? parseInt(psqiPreg007) : 0;

  // Operaciones para resultado de componente 7 de PSQI

  const totalSum8And9 =
    (parseInt(psqiPreg008) || 0) + (parseInt(psqiPreg009) || 0);

  const totalSumComp7 =
    totalSum8And9 <= 0
      ? 0
      : totalSum8And9 >= 1 && totalSum8And9 <= 2
      ? 1
      : totalSum8And9 >= 3 && totalSum8And9 <= 5
      ? 2
      : totalSum8And9 >= 5 && totalSum8And9 <= 6
      ? 3
      : "";

  // Operación para puntuacion global de PSQI

  const totalSumPsqi =
    (psqiPreg006 !== null ? parseInt(psqiPreg006) : 0) +
    (parseInt(totalSumComp2) || 0) +
    (parseInt(totalSumComp3) || 0) +
    (parseInt(totalSumComp4) || 0) +
    (parseInt(totalSumComp5) || 0) +
    (psqiPreg007 !== null ? parseInt(psqiPreg007) : 0) +
    (parseInt(totalSumComp7) || 0);

  let { tratamientoId, pacienteId } = useParams();

  // Definir el array de preguntas
  const psqiQuestions = [
    "psqiPreg001",
    "psqiPreg002",
    "psqiPreg003",
    "psqiPreg004",
    "psqiPreg005a",
    "psqiPreg005b",
    "psqiPreg005c",
    "psqiPreg005d",
    "psqiPreg005e",
    "psqiPreg005f",
    "psqiPreg005g",
    "psqiPreg005h",
    "psqiPreg005i",
    "psqiPreg005j",
    "psqiPreg005k",
    "psqiPreg006",
    "psqiPreg007",
    "psqiPreg008",
    "psqiPreg009",
    "psqiPreg010",
    "psqiPreg010a",
    "psqiPreg010b",
    "psqiPreg010c",
    "psqiPreg010d",
    "psqiPreg010e",
    "psqiPreg010f",
  ];

  const submitPsqi = async (e) => {
    e.preventDefault();
    setMissingQuestionsMessage(""); // Reiniciar mensaje de error
    setIsMissingQuestionsModalOpen(false); // Cerrar modal de error
    setIsCreatingButton(true);

    try {
      // Crear un objeto que mapea cada pregunta con su valor actual
      const psqiQuestionValues = {
        psqiPreg001,
        psqiPreg002,
        psqiPreg003,
        psqiPreg004,
        psqiPreg005a,
        psqiPreg005b,
        psqiPreg005c,
        psqiPreg005d,
        psqiPreg005e,
        psqiPreg005f,
        psqiPreg005g,
        psqiPreg005h,
        psqiPreg005i,
        // psqiPreg005j,
        psqiPreg005k,
        psqiPreg006,
        psqiPreg007,
        psqiPreg008,
        psqiPreg009,
        psqiPreg010,
        psqiPreg010a,
        psqiPreg010b,
        psqiPreg010c,
        psqiPreg010d,
        // psqiPreg010e,
        psqiPreg010f,
      };

      const requiredQuestions = [
        "psqiPreg001",
        "psqiPreg002",
        "psqiPreg003",
        "psqiPreg004",
        "psqiPreg005a",
        "psqiPreg005b",
        "psqiPreg005c",
        "psqiPreg005d",
        "psqiPreg005e",
        "psqiPreg005f",
        "psqiPreg005g",
        "psqiPreg005h",
        "psqiPreg005i",
        "psqiPreg006",
        "psqiPreg007",
        "psqiPreg008",
        "psqiPreg009",
      ];

      // Validación: revisamos solo las preguntas obligatorias
    const allRequiredAnswered = requiredQuestions.every(
      (question) => psqiQuestionValues[question] !== ""
    );

    if (!allRequiredAnswered) {
      // Si alguna de esas preguntas obligatorias no está contestada, lanzamos el error
      setMissingQuestionsMessage(
        "Para que podamos trabajar en tu recuperación y bienestar, necesitamos tus respuestas."
      );
      setIsMissingQuestionsModalOpen(true); // Abrir el modal de error
      setIsCreatingButton(false);
      return; // Evitar el envío del formulario
    }

      // // Contar cuántas preguntas han sido respondidas
      // const answeredQuestions = psqiQuestions.filter(
      //   (question) => psqiQuestionValues[question] !== ""
      // ).length;

      // // Calcular el porcentaje de respuestas completadas
      // const totalQuestions = psqiQuestions.length;
      // const percentage = (answeredQuestions / totalQuestions) * 100;

      // if (percentage < 100) {
      //   setErrorMessage(
      //     "Para que podamos trabajar en tu recuperación y bienestar, necesitamos tus respuestas"
      //   );
      //   setIsErrorModalOpen(true); // Abrir el modal de error
      //   setIsCreatingButton(false);
      //   return; // Evitar el envío del formulario
      // }

      // Si la validación pasa, proceder con el envío
      await PsqiCreate(
        psqiResp,
        metaFecha,
        psqiPreg001,
        psqiPreg002,
        psqiPreg003,
        psqiPreg004,
        psqiPreg005a,
        psqiPreg005b,
        psqiPreg005c,
        psqiPreg005d,
        psqiPreg005e,
        psqiPreg005f,
        psqiPreg005g,
        psqiPreg005h,
        psqiPreg005i,
        psqiPreg005j,
        psqiPreg005k,
        psqiPreg006,
        psqiPreg007,
        psqiPreg008,
        psqiPreg009,
        psqiPreg010,
        psqiPreg010a,
        psqiPreg010b,
        psqiPreg010c,
        psqiPreg010d,
        psqiPreg010e,
        psqiPreg010f,
        tratamientoId,
        pacienteId
      ).then(
        (val) => {
          window.location.replace(`../psqi/${val.id}`);
        },
        (error) => {
          console.log(error);
          setIsCreatingButton(false);
        }
      );
    } catch (err) {
      console.log(err);
      setIsCreatingButton(false);
    }
  };

  return (
    <>
      <div id="content">
        {/* Modal de Adevrtencia al no contestar preguntas necesarias */}
        {isMissingQuestionsModalOpen && (
          <div className={`modal ${isMissingQuestionsModalOpen ? "is-active" : ""}`}>
            <div
              className="modal-background"
              onClick={() => setIsMissingQuestionsModalOpen(false)}
            ></div>
            <div className="modal-card">
              <header className="modal-card-head">
                <p className="modal-card-title">Algo salió mal...</p>
                <button
                  className="delete"
                  aria-label="close"
                  onClick={() => setIsMissingQuestionsModalOpen(false)}
                ></button>
              </header>
              <section className="modal-card-body">{missingQuestionsMessage}</section>
              <footer className="modal-card-foot">
                <button
                  className="button is-danger"
                  onClick={() => setIsMissingQuestionsModalOpen(false)}
                >
                  Cerrar
                </button>
              </footer>
            </div>
          </div>
        )}

        <form
          id="formNewElement"
          className="newRadioButtons"
          onSubmit={submitPsqi}
        >
          <div className="grid--2col">
            <div className="field">
              <label htmlFor="psqiResp">Responsable</label>
              <div className="control">
                <input
                  className="input"
                  id="psqiResp"
                  required
                  type="text"
                  value={psqiResp}
                  onChange={(e) => setPsqiResp(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="metaFecha">Fecha visita</label>
              <div className="control">
                <input
                  className="input"
                  id="metaFecha"
                  required
                  type="date"
                  value={metaFecha}
                  onChange={(e) => setPsqiFecha(e.target.value)}
                />
              </div>
            </div>
          </div>
          <h3>Cuestionario PSQI</h3>
          <p>
            Ayúdanos a optimizar tu tratamiento y observa tu evolución. Completa
            el cuestionario y OBTÉN 10€ A CAMBIO.
          </p>
          <br></br>
          <p>
            Las siguientes preguntas se refieren a tus HÁBITOS DE SUEÑO sólo
            durante el mes pasado. Tus respuestas deben reflejar la contestación
            más acertada para la mayoría de días y noches DURANTE LOS ÚLTIMOS 30
            DÍAS. Por favor, contesta a todas las preguntas.
          </p>
          <br></br>

          <div className="grid--2col">
            <div className="field">
              <label htmlFor="psqiPreg001">
                1. Durante el mes pasado, ¿a qué hora te has ido a la cama
                habitualmente de noche?
              </label>
              <div className="control">
                <input
                  className="input"
                  id="psqiPreg001"
                  required
                  type="time"
                  value={psqiPreg001}
                  onChange={(e) => setPsqiPreg001(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="psqiPreg002">
                2. Durante el mes pasado, ¿cuánto tiempo (en minutos) has
                tardado en dormirte habitualmente?
              </label>
              <div className="control">
                <input
                  className="input"
                  id="psqiPreg002"
                  required
                  type="number"
                  value={psqiPreg002}
                  onChange={(e) => setPsqiPreg002(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="psqiPreg003">
                3. Durante el mes pasado, ¿a qué hora te has levantado
                habitualmente por la mañana?
              </label>
              <div className="control">
                <input
                  className="input"
                  id="psqiPreg003"
                  required
                  type="time"
                  value={psqiPreg003}
                  onChange={(e) => setPsqiPreg003(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="psqiPreg004">
                4. Durante el mes pasado, ¿cuántas horas calculas que habrás
                dormido por la noche?
              </label>
              <div className="control">
                <input
                  className="input"
                  id="psqiPreg004"
                  required
                  type="number"
                  value={psqiPreg004}
                  onChange={(e) => setPsqiPreg004(e.target.value)}
                />
              </div>
            </div>
          </div>

          <p>
            5. Durante el mes pasado, cuántas veces has tenido problemas para
            dormir a causa de...
          </p>

          <div className="form-radio-container">
            <div className="grid--2-col">
              <div className="radio-capt radio--4-col">
                <p>No durante el mes pasado</p>
                <p>Menos de una vez a la semana</p>
                <p>Una o dos veces a la semana</p>
                <p>Tres o más veces a la semana</p>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg005a">
                  a. no poder conciliar el sueño en 30 minutos
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg005a-0">
                    <input
                      id="psqiPreg005a-0"
                      name="psqiPreg005a"
                      type="radio"
                      value="0"
                      checked={psqiPreg005a === "0"}
                      onChange={(e) => setPsqiPreg005a(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg005a-1">
                    <input
                      id="psqiPreg005a-1"
                      name="psqiPreg005a"
                      type="radio"
                      value="1"
                      checked={psqiPreg005a === "1"}
                      onChange={(e) => setPsqiPreg005a(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg005a-2">
                    <input
                      id="psqiPreg005a-2"
                      name="psqiPreg005a"
                      type="radio"
                      value="2"
                      checked={psqiPreg005a === "2"}
                      onChange={(e) => setPsqiPreg005a(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg005a-3">
                    <input
                      id="psqiPreg005a-3"
                      name="psqiPreg005a"
                      type="radio"
                      value="3"
                      checked={psqiPreg005a === "3"}
                      onChange={(e) => setPsqiPreg005a(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg005b">
                  b. despertarme en mitad de la noche o de madrugada
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg005b-0">
                    <input
                      id="psqiPreg005b-0"
                      name="psqiPreg005b"
                      type="radio"
                      value="0"
                      checked={psqiPreg005b === "0"}
                      onChange={(e) => setPsqiPreg005b(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg005b-1">
                    <input
                      id="psqiPreg005b-1"
                      name="psqiPreg005b"
                      type="radio"
                      value="1"
                      checked={psqiPreg005b === "1"}
                      onChange={(e) => setPsqiPreg005b(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg005b-2">
                    <input
                      id="psqiPreg005b-2"
                      name="psqiPreg005b"
                      type="radio"
                      value="2"
                      checked={psqiPreg005b === "2"}
                      onChange={(e) => setPsqiPreg005b(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg005b-3">
                    <input
                      id="psqiPreg005b-3"
                      name="psqiPreg005b"
                      type="radio"
                      value="3"
                      checked={psqiPreg005b === "3"}
                      onChange={(e) => setPsqiPreg005b(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg005c">
                  c. tener que levantarme para ir al servicio
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg005c-0">
                    <input
                      id="psqiPreg005c-0"
                      name="psqiPreg005c"
                      type="radio"
                      value="0"
                      checked={psqiPreg005c === "0"}
                      onChange={(e) => setPsqiPreg005c(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg005c-1">
                    <input
                      id="psqiPreg005c-1"
                      name="psqiPreg005c"
                      type="radio"
                      value="1"
                      checked={psqiPreg005c === "1"}
                      onChange={(e) => setPsqiPreg005c(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg005c-2">
                    <input
                      id="psqiPreg005c-2"
                      name="psqiPreg005c"
                      type="radio"
                      value="2"
                      checked={psqiPreg005c === "2"}
                      onChange={(e) => setPsqiPreg005c(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg005c-3">
                    <input
                      id="psqiPreg005c-3"
                      name="psqiPreg005c"
                      type="radio"
                      value="3"
                      checked={psqiPreg005c === "3"}
                      onChange={(e) => setPsqiPreg005c(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg005d">
                  d. no poder respirar bien
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg005d-0">
                    <input
                      id="psqiPreg005d-0"
                      name="psqiPreg005d"
                      type="radio"
                      value="0"
                      checked={psqiPreg005d === "0"}
                      onChange={(e) => setPsqiPreg005d(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg005d-1">
                    <input
                      id="psqiPreg005d-1"
                      name="psqiPreg005d"
                      type="radio"
                      value="1"
                      checked={psqiPreg005d === "1"}
                      onChange={(e) => setPsqiPreg005d(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg005d-2">
                    <input
                      id="psqiPreg005d-2"
                      name="psqiPreg005d"
                      type="radio"
                      value="2"
                      checked={psqiPreg005d === "2"}
                      onChange={(e) => setPsqiPreg005d(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg005d-3">
                    <input
                      id="psqiPreg005d-3"
                      name="psqiPreg005d"
                      type="radio"
                      value="3"
                      checked={psqiPreg005d === "3"}
                      onChange={(e) => setPsqiPreg005d(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg005e">
                  e. toser o roncar fuertemente
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg005e-0">
                    <input
                      id="psqiPreg005e-0"
                      name="psqiPreg005e"
                      type="radio"
                      value="0"
                      checked={psqiPreg005e === "0"}
                      onChange={(e) => setPsqiPreg005e(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg005e-1">
                    <input
                      id="psqiPreg005e-1"
                      name="psqiPreg005e"
                      type="radio"
                      value="1"
                      checked={psqiPreg005e === "1"}
                      onChange={(e) => setPsqiPreg005e(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg005e-2">
                    <input
                      id="psqiPreg005e-2"
                      name="psqiPreg005e"
                      type="radio"
                      value="2"
                      checked={psqiPreg005e === "2"}
                      onChange={(e) => setPsqiPreg005e(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg005e-3">
                    <input
                      id="psqiPreg005e-3"
                      name="psqiPreg005e"
                      type="radio"
                      value="3"
                      checked={psqiPreg005e === "3"}
                      onChange={(e) => setPsqiPreg005e(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg005f">
                  f. sentir demasiado frío
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg005f-0">
                    <input
                      id="psqiPreg005f-0"
                      name="psqiPreg005f"
                      type="radio"
                      value="0"
                      checked={psqiPreg005f === "0"}
                      onChange={(e) => setPsqiPreg005f(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg005f-1">
                    <input
                      id="psqiPreg005f-1"
                      name="psqiPreg005f"
                      type="radio"
                      value="1"
                      checked={psqiPreg005f === "1"}
                      onChange={(e) => setPsqiPreg005f(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg005f-2">
                    <input
                      id="psqiPreg005f-2"
                      name="psqiPreg005f"
                      type="radio"
                      value="2"
                      checked={psqiPreg005f === "2"}
                      onChange={(e) => setPsqiPreg005f(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg005f-3">
                    <input
                      id="psqiPreg005f-3"
                      name="psqiPreg005f"
                      type="radio"
                      value="3"
                      checked={psqiPreg005f === "3"}
                      onChange={(e) => setPsqiPreg005f(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg005g">
                  g. sentir demasiado calor
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg005g-0">
                    <input
                      id="psqiPreg005g-0"
                      name="psqiPreg005g"
                      type="radio"
                      value="0"
                      checked={psqiPreg005g === "0"}
                      onChange={(e) => setPsqiPreg005g(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg005g-1">
                    <input
                      id="psqiPreg005g-1"
                      name="psqiPreg005g"
                      type="radio"
                      value="1"
                      checked={psqiPreg005g === "1"}
                      onChange={(e) => setPsqiPreg005g(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg005g-2">
                    <input
                      id="psqiPreg005g-2"
                      name="psqiPreg005g"
                      type="radio"
                      value="2"
                      checked={psqiPreg005g === "2"}
                      onChange={(e) => setPsqiPreg005g(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg005g-3">
                    <input
                      id="psqiPreg005g-3"
                      name="psqiPreg005g"
                      type="radio"
                      value="3"
                      checked={psqiPreg005g === "3"}
                      onChange={(e) => setPsqiPreg005g(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg005h">
                  h. tener malos sueños
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg005h-0">
                    <input
                      id="psqiPreg005h-0"
                      name="psqiPreg005h"
                      type="radio"
                      value="0"
                      checked={psqiPreg005h === "0"}
                      onChange={(e) => setPsqiPreg005h(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg005h-1">
                    <input
                      id="psqiPreg005h-1"
                      name="psqiPreg005h"
                      type="radio"
                      value="1"
                      checked={psqiPreg005h === "1"}
                      onChange={(e) => setPsqiPreg005h(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg005h-2">
                    <input
                      id="psqiPreg005h-2"
                      name="psqiPreg005h"
                      type="radio"
                      value="2"
                      checked={psqiPreg005h === "2"}
                      onChange={(e) => setPsqiPreg005h(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg005h-3">
                    <input
                      id="psqiPreg005h-3"
                      name="psqiPreg005h"
                      type="radio"
                      value="3"
                      checked={psqiPreg005h === "3"}
                      onChange={(e) => setPsqiPreg005h(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg005i">
                  i. tener dolor
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg005i-0">
                    <input
                      id="psqiPreg005i-0"
                      name="psqiPreg005i"
                      type="radio"
                      value="0"
                      checked={psqiPreg005i === "0"}
                      onChange={(e) => setPsqiPreg005i(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg005i-1">
                    <input
                      id="psqiPreg005i-1"
                      name="psqiPreg005i"
                      type="radio"
                      value="1"
                      checked={psqiPreg005i === "1"}
                      onChange={(e) => setPsqiPreg005i(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg005i-2">
                    <input
                      id="psqiPreg005i-2"
                      name="psqiPreg005i"
                      type="radio"
                      value="2"
                      checked={psqiPreg005i === "2"}
                      onChange={(e) => setPsqiPreg005i(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg005i-3">
                    <input
                      id="psqiPreg005i-3"
                      name="psqiPreg005i"
                      type="radio"
                      value="3"
                      checked={psqiPreg005i === "3"}
                      onChange={(e) => setPsqiPreg005i(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>

            <div className="field exception-bg">
              <div className="control grid--2col">
                <label htmlFor="psqiPreg005j">
                  j. Otra razón (es), por favor descríbela (s)
                </label>
                <input
                  className="input"
                  type="text"
                  name="psqiPreg005j"
                  id="psqiPreg005j"
                  value={psqiPreg005j}
                  onChange={(e) => setPsqiPreg005j(e.target.value)}
                />
              </div>
            </div>

            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg005k">
                  Durante el mes pasado, ¿con qué frecuencia has tenido
                  problemas de sueño a causa de esto?
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg005k-0">
                    <input
                      id="psqiPreg005k-0"
                      name="psqiPreg005k"
                      type="radio"
                      value="0"
                      checked={psqiPreg005k === "0"}
                      onChange={(e) => setPsqiPreg005k(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg005k-1">
                    <input
                      id="psqiPreg005k-1"
                      name="psqiPreg005k"
                      type="radio"
                      value="1"
                      checked={psqiPreg005k === "1"}
                      onChange={(e) => setPsqiPreg005k(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg005k-2">
                    <input
                      id="psqiPreg005k-2"
                      name="psqiPreg005k"
                      type="radio"
                      value="2"
                      checked={psqiPreg005k === "2"}
                      onChange={(e) => setPsqiPreg005k(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg005k-3">
                    <input
                      id="psqiPreg005k-3"
                      name="psqiPreg005k"
                      type="radio"
                      value="3"
                      checked={psqiPreg005k === "3"}
                      onChange={(e) => setPsqiPreg005k(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="form-radio-container">
            <div className="grid--2-col">
              <div className="radio-capt radio--4-col">
                <p>Muy buena</p>
                <p>Buena</p>
                <p>Mala</p>
                <p>Muy mala</p>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg006">
                  6. Durante el mes pasado, ¿cómo valorarías, en conjunto, la
                  calidad de tu sueño?
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg006-0">
                    <input
                      id="psqiPreg006-0"
                      name="psqiPreg006"
                      type="radio"
                      value="0"
                      checked={psqiPreg006 === "0"}
                      onChange={(e) => setPsqiPreg006(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg006-1">
                    <input
                      id="psqiPreg006-1"
                      name="psqiPreg006"
                      type="radio"
                      value="1"
                      checked={psqiPreg006 === "1"}
                      onChange={(e) => setPsqiPreg006(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg006-2">
                    <input
                      id="psqiPreg006-2"
                      name="psqiPreg006"
                      type="radio"
                      value="2"
                      checked={psqiPreg006 === "2"}
                      onChange={(e) => setPsqiPreg006(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg006-3">
                    <input
                      id="psqiPreg006-3"
                      name="psqiPreg006"
                      type="radio"
                      value="3"
                      checked={psqiPreg006 === "3"}
                      onChange={(e) => setPsqiPreg006(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="form-radio-container">
            <div className="grid--2-col">
              <div className="radio-capt radio--4-col">
                <p>No durante el mes pasado</p>
                <p>Menos de una vez a la semana </p>
                <p>Una o dos veces a la semana </p>
                <p>Tres o más veces a la semana</p>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg007">
                  7. Durante el mes pasado, ¿cuántas veces has tomado medicación
                  (prescrita o de "parafarmacia") para dormir?
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg007-0">
                    <input
                      id="psqiPreg007-0"
                      name="psqiPreg007"
                      type="radio"
                      value="0"
                      checked={psqiPreg007 === "0"}
                      onChange={(e) => setPsqiPreg007(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg007-1">
                    <input
                      id="psqiPreg007-1"
                      name="psqiPreg007"
                      type="radio"
                      value="1"
                      checked={psqiPreg007 === "1"}
                      onChange={(e) => setPsqiPreg007(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg007-2">
                    <input
                      id="psqiPreg007-2"
                      name="psqiPreg007"
                      type="radio"
                      value="2"
                      checked={psqiPreg007 === "2"}
                      onChange={(e) => setPsqiPreg007(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg007-3">
                    <input
                      id="psqiPreg007-3"
                      name="psqiPreg007"
                      type="radio"
                      value="3"
                      checked={psqiPreg007 === "3"}
                      onChange={(e) => setPsqiPreg007(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg008">
                  8. Durante el mes pasado, ¿cuántas veces has tenido problemas
                  para mantenerte despierto mientras conducías, comías, o
                  mantenías una actividad social?
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg008-0">
                    <input
                      id="psqiPreg008-0"
                      name="psqiPreg008"
                      type="radio"
                      value="0"
                      checked={psqiPreg008 === "0"}
                      onChange={(e) => setPsqiPreg008(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg008-1">
                    <input
                      id="psqiPreg008-1"
                      name="psqiPreg008"
                      type="radio"
                      value="1"
                      checked={psqiPreg008 === "1"}
                      onChange={(e) => setPsqiPreg008(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg008-2">
                    <input
                      id="psqiPreg008-2"
                      name="psqiPreg008"
                      type="radio"
                      value="2"
                      checked={psqiPreg008 === "2"}
                      onChange={(e) => setPsqiPreg008(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg008-3">
                    <input
                      id="psqiPreg008-3"
                      name="psqiPreg008"
                      type="radio"
                      value="3"
                      checked={psqiPreg008 === "3"}
                      onChange={(e) => setPsqiPreg008(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="form-radio-container">
            <div className="grid--2-col">
              <div className="radio-capt radio--4-col">
                <p>Ningún problema</p>
                <p>Sólo un ligero problema</p>
                <p>Algo de problema</p>
                <p>Un grave problema</p>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg009">
                  9. Durante el mes pasado, ¿en qué medida ha sido un problema
                  mantener el ánimo para hacer lo que tenías que hacer?
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg009-0">
                    <input
                      id="psqiPreg009-0"
                      name="psqiPreg009"
                      type="radio"
                      value="0"
                      checked={psqiPreg009 === "0"}
                      onChange={(e) => setPsqiPreg009(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg009-1">
                    <input
                      id="psqiPreg009-1"
                      name="psqiPreg009"
                      type="radio"
                      value="1"
                      checked={psqiPreg009 === "1"}
                      onChange={(e) => setPsqiPreg009(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg009-2">
                    <input
                      id="psqiPreg009-2"
                      name="psqiPreg009"
                      type="radio"
                      value="2"
                      checked={psqiPreg009 === "2"}
                      onChange={(e) => setPsqiPreg009(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg009-3">
                    <input
                      id="psqiPreg009-3"
                      name="psqiPreg009"
                      type="radio"
                      value="3"
                      checked={psqiPreg009 === "3"}
                      onChange={(e) => setPsqiPreg009(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="form-radio-container">
            <div className="grid--2-col">
              <div className="radio-capt radio--4-col">
                <p>No pareja o compañero de habitación</p>
                <p>Pareja/ compañero en otra habitación</p>
                <p>Pareja en misma habitación pero no misma cama</p>
                <p>Pareja en la misma cama</p>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg010">
                  10. ¿Tienes pareja o compañero de habitación?
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg010-0">
                    <input
                      id="psqiPreg010-0"
                      name="psqiPreg010"
                      type="radio"
                      value="0"
                      checked={psqiPreg010 === "0"}
                      onChange={(e) => setPsqiPreg010(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg010-1">
                    <input
                      id="psqiPreg010-1"
                      name="psqiPreg010"
                      type="radio"
                      value="1"
                      checked={psqiPreg010 === "1"}
                      onChange={(e) => setPsqiPreg010(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg010-2">
                    <input
                      id="psqiPreg010-2"
                      name="psqiPreg010"
                      type="radio"
                      value="2"
                      checked={psqiPreg010 === "2"}
                      onChange={(e) => setPsqiPreg010(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg010-3">
                    <input
                      id="psqiPreg010-3"
                      name="psqiPreg010"
                      type="radio"
                      value="3"
                      checked={psqiPreg010 === "3"}
                      onChange={(e) => setPsqiPreg010(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
          </div>

          <p>
            Si tienes pareja o compañero de habitación, pregúntale si durante el
            mes pasado has tenido...
          </p>

          <div className="form-radio-container">
            <div className="grid--2-col">
              <div className="radio-capt radio--4-col">
                <p>No durante el mes pasado</p>
                <p>Menos de una vez a la semana</p>
                <p>Una o dos veces a la semana</p>
                <p>Tres o más veces a la semana</p>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg010a">
                  a. ronquidos fuertes
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg010a-0">
                    <input
                      id="psqiPreg010a-0"
                      name="psqiPreg010a"
                      type="radio"
                      value="0"
                      checked={psqiPreg010a === "0"}
                      onChange={(e) => setPsqiPreg010a(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg010a-1">
                    <input
                      id="psqiPreg010a-1"
                      name="psqiPreg010a"
                      type="radio"
                      value="1"
                      checked={psqiPreg010a === "1"}
                      onChange={(e) => setPsqiPreg010a(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg010a-2">
                    <input
                      id="psqiPreg010a-2"
                      name="psqiPreg010a"
                      type="radio"
                      value="2"
                      checked={psqiPreg010a === "2"}
                      onChange={(e) => setPsqiPreg010a(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg010a-3">
                    <input
                      id="psqiPreg010a-3"
                      name="psqiPreg010a"
                      type="radio"
                      value="3"
                      checked={psqiPreg010a === "3"}
                      onChange={(e) => setPsqiPreg010a(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg010b">
                  b. grandes pausas entre respiraciones mientras duermes
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg010b-0">
                    <input
                      id="psqiPreg010b-0"
                      name="psqiPreg010b"
                      type="radio"
                      value="0"
                      checked={psqiPreg010b === "0"}
                      onChange={(e) => setPsqiPreg010b(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg010b-1">
                    <input
                      id="psqiPreg010b-1"
                      name="psqiPreg010b"
                      type="radio"
                      value="1"
                      checked={psqiPreg010b === "1"}
                      onChange={(e) => setPsqiPreg010b(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg010b-2">
                    <input
                      id="psqiPreg010b-2"
                      name="psqiPreg010b"
                      type="radio"
                      value="2"
                      checked={psqiPreg010b === "2"}
                      onChange={(e) => setPsqiPreg010b(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg010b-3">
                    <input
                      id="psqiPreg010b-3"
                      name="psqiPreg010b"
                      type="radio"
                      value="3"
                      checked={psqiPreg010b === "3"}
                      onChange={(e) => setPsqiPreg010b(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg010c">
                  c. contracciones o sacudidas de piernas mientras duermes
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg010c-0">
                    <input
                      id="psqiPreg010c-0"
                      name="psqiPreg010c"
                      type="radio"
                      value="0"
                      checked={psqiPreg010c === "0"}
                      onChange={(e) => setPsqiPreg010c(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg010c-1">
                    <input
                      id="psqiPreg010c-1"
                      name="psqiPreg010c"
                      type="radio"
                      value="1"
                      checked={psqiPreg010c === "1"}
                      onChange={(e) => setPsqiPreg010c(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg010c-2">
                    <input
                      id="psqiPreg010c-2"
                      name="psqiPreg010c"
                      type="radio"
                      value="2"
                      checked={psqiPreg010c === "2"}
                      onChange={(e) => setPsqiPreg010c(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg010c-3">
                    <input
                      id="psqiPreg010c-3"
                      name="psqiPreg010c"
                      type="radio"
                      value="3"
                      checked={psqiPreg010c === "3"}
                      onChange={(e) => setPsqiPreg010c(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
            <div className="field">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg010d">
                  d. episodios de desorientación o confusión mientras duermes
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg010d-0">
                    <input
                      id="psqiPreg010d-0"
                      name="psqiPreg010d"
                      type="radio"
                      value="0"
                      checked={psqiPreg010d === "0"}
                      onChange={(e) => setPsqiPreg010d(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg010d-1">
                    <input
                      id="psqiPreg010d-1"
                      name="psqiPreg010d"
                      type="radio"
                      value="1"
                      checked={psqiPreg010d === "1"}
                      onChange={(e) => setPsqiPreg010d(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg010d-2">
                    <input
                      id="psqiPreg010d-2"
                      name="psqiPreg010d"
                      type="radio"
                      value="2"
                      checked={psqiPreg010d === "2"}
                      onChange={(e) => setPsqiPreg010d(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg010d-3">
                    <input
                      id="psqiPreg010d-3"
                      name="psqiPreg010d"
                      type="radio"
                      value="3"
                      checked={psqiPreg010d === "3"}
                      onChange={(e) => setPsqiPreg010d(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>

            <div className="field exception-bg">
              <div className="control grid--2col">
                <label htmlFor="psqiPreg010e">
                  e. Otra razón (es), por favor descríbela (s)
                </label>
                <input
                  className="input"
                  type="text"
                  name="psqiPreg010e"
                  id="psqiPreg010e"
                  value={psqiPreg010e}
                  onChange={(e) => setPsqiPreg010e(e.target.value)}
                />
              </div>
            </div>
            <div className="field exception-bg">
              <div className="control grid--2col">
                <label className="radio-title" htmlFor="psqiPreg010f">
                  Durante el mes pasado, ¿con qué frecuencia has tenido
                  problemas de sueño a causa de esto?
                </label>
                <div className="radio--4-col">
                  <label className="radio" htmlFor="psqiPreg010f-0">
                    <input
                      id="psqiPreg010f-0"
                      name="psqiPreg010f"
                      type="radio"
                      value="0"
                      checked={psqiPreg010f === "0"}
                      onChange={(e) => setPsqiPreg010f(e.target.value)}
                    />
                    0
                  </label>
                  <label className="radio" htmlFor="psqiPreg010f-1">
                    <input
                      id="psqiPreg010f-1"
                      name="psqiPreg010f"
                      type="radio"
                      value="1"
                      checked={psqiPreg010f === "1"}
                      onChange={(e) => setPsqiPreg010f(e.target.value)}
                    />
                    1
                  </label>
                  <label className="radio" htmlFor="psqiPreg010f-2">
                    <input
                      id="psqiPreg010f-2"
                      name="psqiPreg010f"
                      type="radio"
                      value="2"
                      checked={psqiPreg010f === "2"}
                      onChange={(e) => setPsqiPreg010f(e.target.value)}
                    />
                    2
                  </label>
                  <label className="radio" htmlFor="psqiPreg010f-3">
                    <input
                      id="psqiPreg010f-3"
                      name="psqiPreg010f"
                      type="radio"
                      value="3"
                      checked={psqiPreg010f === "3"}
                      onChange={(e) => setPsqiPreg010f(e.target.value)}
                    />
                    3
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="form-results from-results-new form-results-psqi">
            <h3>Resultados de la autoevaluación PSQI</h3>
            <p>
              <b>Componente 1: Calidad subjetiva del sueño</b>
            </p>
            <p>Puntuación del componente 1 --- {psqiPreg006 !== null ? totalSumComp1 : "No respondido"}</p>
            <p>
              <b>Componente 2: Latencia de sueño</b>
            </p>
            <p>
              Puntuación del pregunta #2 --- {parseInt(psqiPreg002Value) || 0}
            </p>
            <p>Puntuación del pregunta #5a --- {parseInt(psqiPreg005a) || 0}</p>
            <p>Suma #2 y #5a: {totalSum2And5a}</p>
            <p>Puntuación del componente 2 --- {totalSumComp2}</p>
            <p>
              <b>Componente 3: Duración del sueño</b>
            </p>
            <p>Puntuación del componente 3 --- {totalSumComp3}</p>
            <p>
              <b>Componente 4: Eficiencia habitual del sueño</b>
            </p>
            <p>Cantidad de horas dormidas --- {parseInt(psqiPreg004)}</p>
            <p>Hora de levantarse --- {psqiPreg003}</p>
            <p>Hora de acostarse --- {psqiPreg001}</p>
            <p>Numero de horas en la cama --- {diffInHours}</p>
            <p>Eficacia habitual del sueño --- {psqiComp4EficSue} %</p>
            <p>Puntuación del componente 4 --- {totalSumComp4}</p>
            <p>
              <b>Componente 5: Alteraciones del sueño</b>
            </p>
            <p>
              Suma puntuaciones preguntas #5b a #5j --- {totalSumPregPsqi005}
            </p>
            <p>Puntuación del componente 5 --- {totalSumComp5}</p>
            <p>
              <b>Componente 6: Uso de medicación para dormir</b>
            </p>
            <p>Puntuación del componente 6 --- {psqiPreg007 !== null ? totalSumComp6 : "No respondido"}</p>
            <p>
              <b>Componente 7: Disfunción diurna</b>
            </p>
            <p>Sumatorio de preguntas 8 y 9 --- {totalSum8And9}</p>
            <p>Puntuación del componente 7 --- {totalSumComp7}</p>
            <p>
              <b>Puntuación Global PSQI</b>
            </p>
            <p>Puntuación Global PSQI --- {totalSumPsqi}</p>
          </div>
        </form>
      </div>

      <div id="actions">
        <button
          className="button is-link"
          form="formNewElement"
          type="submit"
          disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
        </button>
      </div>
    </>
  );
}
